import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { LabelDesignService } from 'src/app/services/label-design.service';
import { PrintService } from 'src/app/services/print.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-qz-tray-steps',
  templateUrl: './qz-tray-steps.component.html'
})
export class QzTrayStepsComponent implements OnInit {

    qzUrlString = "";
    javaUrlString = "";
    isSystemplatform: string = "";
    @Output() CloseModal = new EventEmitter<any>();
    isQzLatestInstalled : boolean;
    currentVersion: string = '';
    constructor(private _printService:PrintService, private _labeDesign: LabelDesignService,) { }

    ngOnInit() {
        
        this.isSystemplatform   = window.navigator.platform;;
        if(this.isSystemplatform  && (this.isSystemplatform  === 'Mac68K' || this.isSystemplatform  === 'MacPPC' || this.isSystemplatform  === 'MacIntel')) {
            this.qzUrlString =  environment.QzDownloadLinkForMac;
            this.javaUrlString = environment.JavaDownloadLinkforMac;
        } else {
            this.qzUrlString =  environment.QzDownloadLink;
            this.javaUrlString = environment.JavaDownloadLink;
        };
        this.isQzLatestInstalled = this._printService.isQzLatestVersion;
        this.currentVersion = this._printService.getCurrentQzVersion();
     }

    getOS(): 'windows' | 'mac' | 'other' {
        const ua = navigator.userAgent;
        const platform = navigator.platform;

        if (ua.includes('Windows') || platform.includes('Win')) {
            return 'windows';
        }
        if (ua.includes('Mac') || platform.includes('Mac')) {
            return 'mac';
        }
        return 'other';
    }

    getArch(): 'x86' | 'arm64' {
        const ua = navigator.userAgent.toLowerCase();
        const platform = navigator.platform.toLowerCase();
        const navAny = navigator as any;
        if (navAny.userAgentData?.architecture === 'arm64') {
            return 'arm64';
        }
        if (platform.includes('arm') || ua.includes('arm') || ua.includes('aarch64')) {
            return 'arm64';
        }
        return 'x86';
    }

    downloadAndInstallNow() {
        const os = this.getOS();
        const arch = this.getArch();
        const payload = {
            "os": os,    
            "architecture": arch
        };
        this._labeDesign.getQzTryVersion(payload).subscribe({
                next: (blob: Blob) => {
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = 'qz-tray.exe'; 
                    a.click();
                    window.URL.revokeObjectURL(url);
                },
                error: (err) => {
                console.error('Download failed', err);
            }
        });
    }
    
    clickActions(javaLink, QzLink) {
        javaLink.click();
        setTimeout(() => {
            QzLink.click();
        }, 10000);
    }
    clickQzLatestVersionActions(QzLink)
    {
        QzLink.click();
    }

    Cancel() {
        this.CloseModal.emit(null);
    }

}
